// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 678px) {\n.details-box .details-item.with-values.inner-page-style .details-value {\n    width: 100%;\n    word-break: break-word;\n}\n.sanctions-details-page .details-box {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
